import axios from 'axios';
import { notifications } from '@mantine/notifications';
import { API_CONFIG } from '../../config/config';
import { authService } from '../../services/auth/authService';

const api = axios.create({
  baseURL: API_CONFIG.DC_BASE_URL,
  timeout: 40000,
  headers: { 'Content-Type': 'application/json' },
});

// ============================================================
// INTERCEPTOR: Agregar Authorization header
// Solicita token al authService (no conoce la implementación)
// ============================================================
api.interceptors.request.use(
  async (config) => {
    const token = await authService.getToken();
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// ============================================================
// INTERCEPTOR: Manejo de errores
// ============================================================
api.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error.response?.status;
    const msg = error.response?.data?.message || error.message || 'Error de conexión';
    
    notifications.show({
      title: 'Error al cargar datos',
      message: `${status ? `[${status}] ` : ''}${msg}`,
      color: 'red',
      autoClose: 5000,
    });

    return Promise.reject(error);
  }
);

export default api;
